import { CornerDownRight } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

/**
 * Shows which parent task a sub-task belongs to (e.g. "↳ FR-100") — used on the
 * board's Custom view, where a sub-task can appear away from its parent (a
 * different personal column, or the parent isn't on the board at all), so the
 * relationship isn't obvious from position alone. Distinct from the section
 * chip (where it lives) — this is what it's a part of.
 */
export function ParentChip({
  label,
  parentTitle,
  className,
}: {
  /** Display id ("FR-100") when the list has an item key, else the parent title. */
  label: string;
  /** Full parent title, for the tooltip. */
  parentTitle?: string;
  className?: string;
}) {
  return (
    <Badge
      variant="outline"
      className={cn('flex-shrink-0 gap-1 px-1.5 py-0 text-[10px] text-muted-foreground', className)}
      title={parentTitle ? `Sub-task of ${parentTitle}` : 'Sub-task'}
    >
      <CornerDownRight className="h-2.5 w-2.5 flex-shrink-0" />
      <span className="max-w-[10rem] truncate">{label}</span>
    </Badge>
  );
}
